module.exports = __webpack_public_path__ + "img/cyan.9f740081.webp";